import React from 'react';

const STEPS = [
  {
    key: 'meter',
    label: 'Smart Meter',
    desc: 'GRIDx meter measures consumption at the point of use.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
        <rect x="4" y="3" width="16" height="18" rx="1" />
        <rect x="7" y="7" width="10" height="6" rx="0.5" />
        <path d="M7 17h4M7 20h7" />
      </svg>
    ),
  },
  {
    key: 'signal',
    label: 'Connectivity',
    desc: '4G, 3G or fibre — the meter\'s built-in router carries the data out.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
        <path d="M5 12.5a10 10 0 0 1 14 0" />
        <path d="M8.5 16a5 5 0 0 1 7 0" />
        <circle cx="12" cy="19" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    key: 'cloud',
    label: 'GRIDx Cloud',
    desc: 'Readings are collected, validated and stored centrally.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
        <path d="M7 18a4 4 0 0 1-.5-7.97A5.5 5.5 0 0 1 17.3 8.3 4.5 4.5 0 0 1 17 18H7z" />
      </svg>
    ),
  },
  {
    key: 'data',
    label: 'Real-Time Data',
    desc: 'Consumption, tamper alerts and token balances, processed instantly.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
        <path d="M3 17l5-5 4 4 8-9" />
        <path d="M14 7h6v6" />
      </svg>
    ),
  },
  {
    key: 'homes',
    label: 'Homes & Utilities',
    desc: 'Consumers see usage; utilities see the whole network.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
        <path d="M3 11l9-7 9 7" />
        <path d="M5 10v10h14V10" />
      </svg>
    ),
  },
];

const EcosystemSection = () => (
  <section className="gh-section gh-eco">
    <div className="gh-section__inner">
      <span className="eyebrow">The GRIDx ecosystem</span>
      <h2 className="gh-section__title">One meter. A complete data pipeline.</h2>
      <p className="gh-section__sub">
        Every GRIDx meter is a node on the network — not an isolated device. Here&apos;s
        how a single reading becomes actionable information.
      </p>

      <div className="gh-eco__flow">
        {STEPS.map((step, i) => (
          <React.Fragment key={step.key}>
            <div className="gh-eco__step">
              <div className="gh-eco__icon">{step.icon}</div>
              <h3 className="gh-eco__label">{step.label}</h3>
              <p className="gh-eco__desc">{step.desc}</p>
            </div>
            {i < STEPS.length - 1 && (
              <div className="gh-eco__connector" aria-hidden="true">
                <svg viewBox="0 0 100 10" preserveAspectRatio="none">
                  <line x1="0" y1="5" x2="100" y2="5" className="gh-eco__connector-base" />
                  <line x1="0" y1="5" x2="100" y2="5" className="gh-eco__connector-pulse" style={{ animationDelay: `${i * 0.5}s` }} />
                </svg>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  </section>
);

export default EcosystemSection;
